import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import Subscription from 'components/Subscription'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { SubContainer, LinkButton } from '../styles'

export default function Plans () {
  const [loading, setLoading] = useState (true)
  const [subscription, setSubscription] = useState (null)
  const company = AuthService.getUser ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getSubscription ()
  }, [])

  const getSubscription = async () => {
    try {
      setLoading (true)

      const { data: subscription } = await cutileiApi.get (
        `/companies/${company.id}/subscriptions`,
        requestConfig
      )
      
      setSubscription (subscription)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  if (loading) return <Loading/>

  return (
    <SubContainer>
      {subscription ? (
        <Subscription data={subscription}/>
      ) : (
        <LinkButton to='/company/new_subscription'>
          Assinar
        </LinkButton>
      )}
    </SubContainer>
  )
}
